import { Component } from '@angular/core';

@Component({
  selector: 'app-common-error-display',
  templateUrl: './common-error-display.component.html',
  styleUrls: ['./common-error-display.component.scss']
})
export class CommonErrorDisplayComponent  {

  

}